/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { ISource, SourceConfig } from '@stores/source';
import SingerSourceSettings from '@components/sources/source/singerSource/singerSourceConfig';
import { apiAuthCaller } from '@services/apiCaller';
import { SmartRetry } from '@utils/retry';
import { ISourceDefinition } from '@stores/sourceDefinitionsList';
import { TAB_NAMES } from '../source-view';
import SelectResources from '../source/singerSource/singerResourceSelection';
import CloudSource from './cloudSource';
import { ResourcesComponentProps, ConfigurationComponentProps } from './sourceCategory';
import { BASE_URLS } from '../constants';
import removeNullValues from '@utils/removeNullValues';

class SingerSource extends CloudSource {
  override getTabs(source: ISource) {
    return [
      TAB_NAMES.DESTINATIONS,
      TAB_NAMES.SYNCS,
      TAB_NAMES.CONFIGURATION,
      TAB_NAMES.RESOURCES,
      TAB_NAMES.SETTINGS,
    ];
  }

  override getResourcesComponent({
    source,
    onChange,
    disabled,
    onSingleResourceOrLess,
  }: ResourcesComponentProps): JSX.Element {
    return (
      <SelectResources
        catalog={source?.config?.catalogJSONSchema}
        // when editing resources will be in form of string only.
        selectedResources={source?.config?.catalog?.streams?.map((elem) => elem.stream.name)}
        onSingleResourceOrLess={onSingleResourceOrLess}
        sourceDefinition={source!.sourceDef}
        onChange={(catalog, _, resources) => {
          onChange({ resources, catalog });
        }}
        disabled={disabled}
      />
    );
  }

  override getCredentialSettings(_: unknown) {
    return null;
  }

  override getConfigurationComponent(props: ConfigurationComponentProps): JSX.Element {
    const { source, onChange, disabled } = props;
    const { sourceDef, config, secretConfig } = source;
    const [newConfig, setNewConfig] = React.useState(config.config);
    return (
      <SingerSourceSettings
        configSchema={config.configJSONSchema}
        initialSettings={newConfig}
        secretConfig={secretConfig}
        onSettingsChange={(sourceConfig, schema, isValid) => {
          setNewConfig(sourceConfig);
          onChange(sourceConfig, isValid);
        }}
        sourceDefinition={sourceDef}
        disabled={disabled}
      />
    );
  }

  override transformSourceConfig(config: SourceConfig): Record<string, unknown> {
    return { config: removeNullValues(config) };
  }

  override transformResourcesConfig(config: SourceConfig): Record<string, unknown> {
    return { catalog: config.catalog, resources: config.resources };
  }

  override async validateSource(
    token: string,
    config: SourceConfig,
    source: { id?: string; config?: SourceConfig; sourceDef: ISourceDefinition },
  ): Promise<{ valid: boolean; reason: string }> {
    const retry = new SmartRetry<{ data: { valid?: boolean; error: string } }>({ times: 2 });
    let params = {};
    if (source) {
      params = { sourceId: source.id };
    }

    let valid = false;
    let reason = '';
    await retry
      .exec(() =>
        apiAuthCaller(token).post(
          `${BASE_URLS.SOURCES_INFO}/rudder_custom/validate`,
          {
            configJSONSchema: source?.config?.configJSONSchema,
            role: source.sourceDef.name,
            config,
            image: source.sourceDef.options!.image,
          },
          { params },
        ),
      )
      .then((resp) => {
        const responseData = resp.data;
        valid = Boolean(responseData.valid);
        reason = responseData.error;
      })
      .catch((e) => {
        reason = `Failed to validate sourcec: ${e?.response?.data || 'Unknown error'}`;
      });

    return {
      valid,
      reason,
    };
  }
}
export default SingerSource;
